import { AppController } from "../AppController";
var OrganizationNotFoundPage = /** @class */ (function () {
    function OrganizationNotFoundPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(OrganizationNotFoundPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    return OrganizationNotFoundPage;
}());
export { OrganizationNotFoundPage };
